module.exports = __webpack_public_path__ + "static/media/teacher-public.bcaa7dd2.svg";